import { render, staticRenderFns } from "./AlumniCcidRequest.vue?vue&type=template&id=014fd001"
import script from "./AlumniCcidRequest.vue?vue&type=script&lang=js"
export * from "./AlumniCcidRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports